import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import AuthPage from './components/AuthPage';
import EditorPage from './components/EditorPage';
import ProjectsPage from './components/ProjectsPage';
import PublicViewerPage from './components/PublicViewerPage';
import { useSession } from './state/session';

function RequireAuth({ children }: { children: JSX.Element }) {
  const status = useSession((s) => s.status);
  const location = useLocation();
  if (status === 'unknown') {
    return <div className="app-loading">connecting…</div>;
  }
  if (status === 'anonymous') {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  // 'authenticated' or 'offline' (backend down: let the editor shell load)
  return children;
}

export default function App() {
  const init = useSession((s) => s.init);
  useEffect(() => {
    void init();
  }, [init]);

  return (
    <Routes>
      <Route path="/login" element={<AuthPage />} />
      <Route path="/p/:token" element={<PublicViewerPage />} />
      {/* Collab link: unguarded like the public viewer — anyone with the token
          may edit, logged in or not. The token authorizes the sync handshake. */}
      <Route path="/collab/:token" element={<EditorPage collab />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <ProjectsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/edit/:id"
        element={
          <RequireAuth>
            <EditorPage />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
